import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { ApprovalsKpiDashboard } from './components/ApprovalsKpiDashboard';
import { ApprovalsModulesGrid } from './components/ApprovalsModulesGrid';
import { RecentApprovalActivity } from './components/RecentApprovalActivity';

export function ApprovalsPage() {
  return (
    <PageLayout
      title="Phê duyệt & Trình ký"
      description="Trung tâm kiểm soát, xét duyệt các tờ trình, thanh toán và xử lý quy trình điện tử"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <ApprovalsKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Nghiệp vụ Phê duyệt (Approval Operations)
              </h3>
            </div>
            <div className="flex-1">
              <ApprovalsModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Biến động gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentApprovalActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default ApprovalsPage;
